export default "__VITE_ASSET__9764bc09__"